<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras interior">
        <div class="container">
          <div
            class="row pb-5 mb-5"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-12">
              <div class="row pt-2 pt-lg-0 white">
                <!-- <div class="col-12 pb-4 fXG text-center">
                  ¡Bienvenido a
                  <br class="d-block d-lg-none" />
                  <span class="naranja">Maestros de la Parrilla</span>!
                </div> -->
                <div class="col-8 offset-2 col-sm-4 offset-sm-4 pb-5">
                  <img class="img-fluid" src="../../assets/imgs/logomaster.png" alt="">
                </div>
                <div class="col-12 pb-3 fXG text-center text-md-center">
                  ¡Hola
                  <span class="naranja">{{
                    this.$store.state.user.nombre
                  }}</span
                  >!
                </div>
                <p class="text-center w-100 fG">
                  Son 9 Master Classes, una cada semana con estilo y técnicas distintas, pero con una pasión a la parilla que hace a nuestro grill team estar unidos por el asado.
                </p>
              </div>
            </div>
          </div>

          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
            v-if="cursos != null"
          >
            <div class="col-12">
              <div class="row pt-2 pt-lg-0">
                <div class="col-12 col-md-6 pb-5" :class="'order-'+slide.order" v-for="(slide, i) in cursos" :index="i" v-bind:key="i">
                  <div class="row">
                    <div class="col-12 text-center">
                      <h2 class="fXG naranja">{{slide.maestro}}</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5 pb-5 fXG text-center text-md-center">
                      
                      <img class="img-fluid" :src="require('../../assets/imgs/chefs/'+slide.img)" :alt="slide.titulo">
                    </div>
                    <div class="col-7 pb-3 fG text-left">
                      <div class="white">
                        <p>
                          Master Class: {{slide.titulo}}
                        </p>
                        <p v-html="slide.fecha"></p>
                      </div>
                      <p>
                        <router-link :to="'/cursos/video/'+
                        slide.id" class="btn btnsup btnsup2 w-100">
                          {{slide.videotxt}}
                        </router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="cursos carouselcont">
          <div class data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-12">
              <div class="row pt-2 pt-lg-0 white">
                <div class="col-12 text-center px-0">
                  <div class="seleccion" v-if="cursos != null">
                    <carousel-3d ref="carruselcursos" :controls-visible="true" @after-slide-change="onAfterSlideChange">
                      <slide v-for="(slide, i) in cursos" :index="i" v-bind:key="i">
                        <img
                          :src="require('../../assets/imgs/cursos/'+slide.img)"
                          :alt="slide.titulo"
                        />
                      </slide>
                    </carousel-3d>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Footer from "../../Components/Footer.vue";

import Vue from "vue";
// import Vue2TouchEvents from "vue2-touch-events";
// Vue.use(Vue2TouchEvents);
import { Carousel3d, Slide } from "vue-carousel-3d";

//Vue.use(Carousel3d);

export default {
  name: "AcademiaDigital",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "",
      password: "",
      info: false,
      cursos: null,
      index: 0,
    };
  },
  mounted: function () {
    // Opción múltiple
    // relacionar columnas
    // eliminar el incorrecto
    // poner en orden varios elementos

    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.$store.state.user = JSON.parse(
      localStorage.getItem("useracademiadigital")
    );
    AOS.init();
    this.cursos = this.$store.state.cursos;

    var vm = this;
    // setTimeout(function(){
    //   vm.$refs.carruselcursos.goSlide(2);
    // },1000);
    // // Vue.nextTick(
    // //   function () {
    // //     vm.$refs.carruselcursos.goSlide(6);
    // //   }.bind(vm)
    // // );
  },
  components: {
    "header-mx": Header,
    "footer-mx": Footer,
    //Carousel3d,
    //Slide
  },
  methods: {
    clickComprar() {
      this.$gtag.event("Click comprar", {
        event_category: "MDLP",
      });
    },
    clickRecetario() {
      this.$gtag.event("Descarga recetario", {
        event_category: "MDLP",
      });
    },
    comenzar() {
      console.log("submit");
      var vm = this;

      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        email: vm.$store.state.user.email,
        id_curso: this.cursos[this.index].id,
        nombre_curso:
          this.cursos[this.index].clase + ": " + this.cursos[this.index].titulo,
        nombre_video:
          this.cursos[this.index].clase + ": " + this.cursos[this.index].titulo,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "comenzar-curso.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              this.$router.push("/cursos/video/" + this.cursos[this.index].id);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    toggleInfo() {
      this.info = !this.info;
    },
    onAfterSlideChange(index) {
      /*console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );*/
      this.index = index;
    },
    swipeHandler(direction) {
      console.log(direction); // May be left / right / top / bottom
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        matricula: this.matricula,
        password: this.password,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "home/login.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //localStorage.setItem('user', res.user);
              this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              vm.$store.state.user = this.$cookie.get("useracademiadigital");
              this.$router.push(res.url);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
  },
};
</script>

